import CalendarView from './CalendarView';
import { CALENDAR } from '../../utils/constant';

const calendarRoutes = [
  {
    path: '/calendar',
    element: <CalendarView />,
    permission: CALENDAR,
  },
];

export default calendarRoutes;
